<template>
  <content-box width="836px" class="dentsu-bridge--wrap">
    <div class="layout-box">
      <div class="content__header">
        <i class="icon icon--bridge-layer"></i>
        <p class="title">{{ $t('dashboard.dentsuBridge.title') }} : {{ userData.userId }}</p>
        <p class="desc">{{ $t('dashboard.dentsuBridge.desc') }}</p>
      </div>
      <data-table
        :headers="headers">
        <colgroup slot="colgroup">
          <col width="226">
          <col width="209">
          <col width="95">
          <col width="135">
          <col width="*">
        </colgroup>
        <tbody>
        <tr v-for="(item, index) in dentsuClientList" :key="index">
          <td class="row__id">{{ item.userId }}</td>
          <td class="row__user-name">{{ item.userName }}</td>
          <td class="row__register-date align-center">{{ item.regDate | dashDate }}</td>
          <td class="row__state align-center">{{ item.planName }}</td>
          <td class="row__btn" @click="getClientAuthSetLogin(item.userId)">
            <ui-button primary>{{ $t('dashboard.dentsuBridge.login') }}</ui-button>
          </td>
        </tr>
        </tbody>
      </data-table>
    </div>
  </content-box>
</template>

<script>
import ContentBox from '@/components/ui/ContentBox'
import DataTable from '@/components/ui/DataTable'
import UiButton from '@/components/ui/UiButton'
import { setAuthData } from '@/libs/auth-helper'
import { getClientAuth } from '@/api/user'

export default {
  components: {
    ContentBox,
    DataTable,
    UiButton
  },
  data () {
    return {
      headers: [
        {
          name: this.$t('common.table.header.id'),
          alignLeft: true
        },
        {
          name: this.$t('common.table.header.company'),
          alignLeft: true
        },
        {
          name: this.$t('common.table.header.registerDate')
        },
        {
          name: this.$t('common.table.header.planState')
        },
        {
          name: ''
        }
      ]
    }
  },
  props: [
    'userData',
    'dentsuClientData'
  ],
  computed: {
    dentsuClientList () {
      return this.dentsuClientData
    }
  },
  methods: {
    getClientAuthSetLogin (clientId) {
      getClientAuth(clientId).then(response => {
        setAuthData(response)
        this.$router.go()
      })
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.dentsu-bridge--wrap {
  @include positionXYcenter;

  .layout-box {
    margin-top: 50px;
    margin-bottom: 45px;
    padding: 0px 35px;
    max-height: 492px;
    overflow: auto;
  }

  .content__header {
    text-align: center;
    .title {
      margin-top: 15px;
      font-size: 20px;
      font-weight: bold;
      color: #444444;
    }
    .desc {
      margin-top: 11px;
      font-size: 14px;
      color: #2f2f2f;
    }
  }
  .tbl {
    margin-top: 25px;

    thead th {
      height: 40px;
      font-size: 13px;
    }

    tbody td {
      padding-left: 10px;
      height: 60px;
      border-bottom: 1px solid #ebebeb;

      &.align-center {
        text-align: center;
      }
      &.row__id {
        font-weight: 500;
        font-size: 14px;
        color: #2f2f2f;
      }
      &.row__user-name {
        font-size: 14px;
        color: #2f2f2f;
      }
      &.row__register-date {
        font-size: 13px;
        color: #666666;
      }
      &.row__state {
        font-size: 14px;
        color: #2f2f2f;
      }
    }
  }
}
</style>
